<manual-payroll-header
  [payrollStartData]="startData"
  (onCancelButton)="returnToHub()"></manual-payroll-header>

<div class="text-end my-3">
  <a (click)="print()" class="cp-green d-print-none me-3"> Print <i class="fas fa-print"></i> </a>
</div>

<ng-container>
  <div ngbAccordion class="payrollAccordion">
    <div
      ngbAccordionItem
      ngbAccordionItem="paylineDetails"
      #paylineDetails="ngbAccordionItem"
      [collapsed]="false">
      <h2 ngbAccordionHeader [title]="paylineDetails.collapsed ? 'Click to View' : 'Click to Hide'">
        <button ngbAccordionButton>
          <h4>Payline Details</h4>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div *ngIf="payroll?.EmployeePays && configSetupData">
              <div *ngFor="let pay of payroll.EmployeePays">
                <payline-detail-table
                  [clientCode]="clientCode"
                  [configSetupData]="configSetupData"
                  [pay]="pay"
                  [payroll]="payroll">
                </payline-detail-table>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-container>
